{
  "attorney": {
    "header": {
      "title": "Panel de Abogado"
    },
    "nav": {
      "filingQueue": "Cola de Registro",
      "approvalQueue": "Cola de Aprobación",
      "clients": "Mis Clientes",
      "correspondence": "Correspondencia",
      "deadlines": "Fechas Límite",
      "jurisdictions": "Jurisdicciones",
      "assignments": "Gestionar Asignaciones",
      "backToDashboard": "Volver al Panel"
    },
    "filingQueue": {
      "title": "Cola de Registro",
      "loading": "Cargando cola de registro...",
      "error": "Error al cargar la cola de registro",
      "empty": "No hay registros en cola",
      "allCountries": "Todos los Países",
      "allStatuses": "Todos los Estados",
      "statusPending": "Pendiente",
      "statusFiled": "Registrado",
      "refresh": "Actualizar"
    },
    "filingCard": {
      "allFiled": "Todo registrado",
      "partiallyFiled": "En progreso",
      "pending": "Pendiente",
      "client": "Cliente",
      "classes": "Clases",
      "country": "País",
      "status": "Estado",
      "ipOfficeRef": "Ref. Oficina de PI",
      "actions": "Acciones",
      "jurisdictionsFiled": "jurisdicciones registradas"
    },
    "jurisdiction": {
      "pending": "Pendiente",
      "filed": "Registrado",
      "accepted": "Aceptado",
      "registered": "Registrado",
      "rejected": "Rechazado",
      "fileNow": "Registrar Ahora",
      "viewDocs": "Ver Docs",
      "view": "Ver",
      "editRef": "Editar Ref"
    },
    "fileNowModal": {
      "title": "Registrar en {{country}}",
      "applicationRef": "Referencia de Solicitud",
      "useReference": "Use esta referencia en todos los formularios de la Oficina de PI:",
      "copy": "Copiar",
      "copied": "¡Copiado!",
      "ipOfficePortal": "Portal de la Oficina de PI",
      "openPortal": "Abrir Portal",
      "instructions": "Instrucciones",
      "step1": "Inicie sesión en el portal de {{office}}",
      "step2": "Inicie una nueva solicitud de marca",
      "step3": "Ingrese \"{{appId}}\" en el campo \"Su Referencia\"",
      "step4": "Cargue el documento de registro generado",
      "step5": "Complete el pago en la Oficina de PI",
      "step6": "Anote el número de referencia de {{office}}",
      "documents": "Documentos",
      "afterFiling": "Después del registro, ingrese el número de referencia de la Oficina de PI:",
      "cancel": "Cancelar",
      "markAsFiled": "Marcar como Registrado",
      "marking": "Marcando..."
    },
    "approvalQueue": {
      "title": "Cola de Aprobación",
      "loading": "Cargando cola de aprobación...",
      "error": "Error al cargar la cola de aprobación",
      "empty": "No hay tareas pendientes de aprobación",
      "allTypes": "Todos los Tipos",
      "officeAction": "Respuestas a Acciones de Oficina",
      "opposition": "Respuestas a Oposiciones",
      "renewal": "Solicitudes de Renovación",
      "refresh": "Actualizar"
    },
    "approvalCard": {
      "officeAction": "Respuesta a Acción de Oficina",
      "opposition": "Respuesta a Oposición",
      "renewal": "Solicitud de Renovación",
      "urgent": "Urgente",
      "high": "Alta",
      "medium": "Media",
      "low": "Baja",
      "successLikelihood": "Probabilidad de Éxito",
      "noSummary": "Sin resumen disponible",
      "daysLeft": "{{days}} días restantes",
      "overdue": "¡Vencido!",
      "review": "Revisar Borrador"
    },
    "draftReview": {
      "title": "Revisar Borrador de IA",
      "summary": "Resumen",
      "estimatedSuccess": "Éxito Estimado",
      "keyArguments": "Argumentos Clave",
      "similarCases": "Casos Similares Referenciados",
      "draftContent": "Contenido del Borrador",
      "view": "Ver",
      "edit": "Editar",
      "editPlaceholder": "Editar el borrador...",
      "rejectReason": "Motivo del Rechazo",
      "rejectPlaceholder": "Explique por qué se rechaza este borrador...",
      "back": "Volver",
      "reject": "Rechazar",
      "confirmReject": "Confirmar Rechazo",
      "rejecting": "Rechazando...",
      "approve": "Aprobar",
      "approveWithChanges": "Aprobar con Cambios",
      "approving": "Aprobando..."
    }
  }
}
